'use client';

import { useState } from 'react';
import config from '@/config';

export default function TiltedVideo() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative"
      style={{ perspective: '1000px' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="relative rounded-2xl overflow-hidden transition-all duration-500 ease-out"
        style={{
          transform: isHovered
            ? 'rotateY(0deg) scale(1.02)'
            : 'rotateY(-20deg)',
          transformStyle: 'preserve-3d',
          boxShadow: isHovered
            ? '0 25px 50px rgba(0, 0, 0, 0.25)'
            : '-30px 30px 60px rgba(0, 0, 0, 0.3)',
        }}
      >
        <video className="w-full rounded-2xl" autoPlay muted loop playsInline>
          <source
            src={`${config.imagesBaseUrl}/landing/ai-quiz.mp4`}
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  );
}
